
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import BasicInfoForm from "./basic-info/BasicInfoForm";
import QuickStartSection from "./basic-info/QuickStartSection";
import { RefundFormValues } from "@/hooks/use-refund-form";

interface BasicInfoStepProps {
  values: RefundFormValues;
  errors: Record<string, string>;
  onChange: (field: string, value: string) => void;
}

const BasicInfoStep = ({ values, errors, onChange }: BasicInfoStepProps) => {
  const handleSampleSelect = (sample: any) => {
    console.log('BasicInfoStep: Sample selected:', sample);
    
    // Fill form with sample data
    onChange('merchant', sample.merchant);
    onChange('product', sample.product);
    onChange('issue', sample.issue);
    onChange('amount', sample.amount.toString());
    if (sample.orderNumber) {
      onChange('orderNumber', sample.orderNumber);
    }
  };

  return (
    <Card className="w-full max-w-2xl mx-auto">
      <CardContent className="pt-6 space-y-6">
        <QuickStartSection onSampleSelect={handleSampleSelect} />
        <BasicInfoForm 
          values={values} 
          errors={errors} 
          onChange={onChange} 
        />
      </CardContent>
    </Card>
  );
};

export default BasicInfoStep;
